import { localStorageGetItem, localStorageSetItem } from "../../localStorage"
import { getUTMParams, getCookieValue } from "./trackingUtils"

function getStoreByKeyValue(key, valueKey) {
  key = `${pipelineConfig.pathPrefix}:${key}`
  const data = localStorageGetItem(key) ?? null
  let store = null

  if (data) {
    store = JSON.parse(data)
  }
  if (store && store.values && valueKey && store.values[valueKey]) {
    return store.values[valueKey]
  }
  return store ?? null
}

function getFromLocalStorage(key) {
  const LOCAL_STORAGE_KEY = "data"
  const val = getStoreByKeyValue(LOCAL_STORAGE_KEY, key)
  return typeof val === "string" ? val : null
}

export class TrackingServiceSegment {
  constructor(pipelineConfig) {
    this.defaultParameters = {
      pageCode: window.location.pathname.split(pipelineConfig.pathPrefix)[1].split("/")[0] || null,
      page: window.location.pathname.split(pipelineConfig.pathPrefix)[1].split("/")[0] || null,
      pipe: pipelineConfig.pathPrefix,
      claritySessionID: decodeURIComponent(getCookieValue("_clsk")).split("^")[0] || null,
      pipe_id: pipelineConfig.pipelineId,
      language: pipelineConfig.language,
      geography: pipelineConfig.geography,
      brand_code: pipelineConfig.brandCode,
      brand: pipelineConfig.brandCode,
      pipe_series: pipelineConfig.series,
      pipeSeries: pipelineConfig.series,
      eventSourceSystem: "cppv3",
      eventSourcePlatform: "web",
      klaviyoAccount: window.pipelineConfig.klaviyoPublicKey || null,
    }

    const initSegmentMiddleware = () => {
      if (window.analytics && window.analytics.addSourceMiddleware) {
        window.analytics.addSourceMiddleware(({ payload, next }) => {
          const defaultProperties = payload.obj.properties

          payload.obj.properties = Object.assign({}, defaultProperties, this.defaultParameters)
          const emailValue = getFromLocalStorage("email")
          if (emailValue) {
            payload.obj.properties.email = emailValue
          }

          next(payload)
        })
      } else {
        console.error(`[Segment] Analytics not available:`)
      }
    }

    initSegmentMiddleware()
  }

  mergeData(data) {
    return { ...this.defaultParameters, ...data }
  }

  internalIsUserIdentified() {
    const store = window.Alpine.store("data")
    const storeData = (store && store.values) || {}
    const data = { segmentUserId: storeData.segmentUserId || "" }

    if (!storeData.segmentUserId || !storeData.email) return

    this.isUserIdentified(data).then((isIdentified) => {
      if (!isIdentified) {
        data.email = storeData.email
        this.trackIdentify(data)
      }
    })
  }

  trackClick(customData) {
    this.internalIsUserIdentified()

    const utmParams = getUTMParams()
    const data = this.mergeData({ ...customData, ...utmParams })

    window.analytics.track("click", data)
  }

  trackPageView() {
    this.internalIsUserIdentified()

    window.analytics.page(this.defaultParameters.pageCode, {
      ...getUTMParams(),
      pageCode: this.defaultParameters.pageCode,
    })
  }

  trackIdentify(customData) {
    const data = this.mergeData(customData)

    localStorageSetItem("ajs_user_id", data.segmentUserId)
    window.analytics.identify(data.segmentUserId, { email: data.email })
  }

  trackSystemEvent(customData) {
    this.internalIsUserIdentified()

    const utmParams = getUTMParams()
    const data = this.mergeData({ ...customData, ...utmParams })

    window.analytics.track("system event", data)
  }

  resetUserData() {
    window.analytics.reset()
    window.analytics.setAnonymousId()
  }

  setEventToSessionStorage(customData) {
    // Do nothing, cause segment covers this edge-cases
  }

  trackSessionStorageClickEvent(payload) {
    // Do nothing, cause segment covers this edge-cases
  }

  async isUserIdentified(customData) {
    if (!customData.segmentUserId) {
      return false
    }

    // Sanitize because of different browsers
    let rawValue = localStorageGetItem("ajs_user_id")
    let segmentUserId
    try {
      segmentUserId = JSON.parse(rawValue)
    } catch {
      segmentUserId = rawValue
    }

    if (segmentUserId !== customData.segmentUserId) {
      return false
    }

    return true
  }
}
